import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface LeaveUpdateResponse {
  success: boolean;
  message: string;
  data: {
    _id: string;
    leaveType: string;
    totalLeaves: number;
    updatedAt: string;
  };
}

export type LeaveUpdatePayload = {
  leaveType: string;
  action: "increase" | "decrease";
  amount: number;
};

const updateLeaveByAdmin = async ({
  id,
  payload,
}: {
  id: string;
  payload: LeaveUpdatePayload;
}): Promise<LeaveUpdateResponse> => {
  const { data } = await customAxios.patch<LeaveUpdateResponse>(
    `/leaves/admin-update/${id}`,
    payload
  );
  return data;
};

export const useAdminUpdateLeave = () => {
  const queryClient = useQueryClient();

  return useMutation<
    LeaveUpdateResponse,
    AxiosError,
    { id: string; payload: LeaveUpdatePayload }
  >({
    mutationFn: updateLeaveByAdmin,
    onSuccess: async (data) => {
      showNotification({
        title: "Success",
        message: data.message,
        color: "green",
      });

      await queryClient.invalidateQueries(["leaves"]);
    },
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to update leave",
        color: "red",
      }),
  });
};
